import React from 'react';
import BlastResults from '../blast_sms/BlastResults';

function EmailBlastResults() {
    return (
        <BlastResults
            listPath="/blast/email"
            listLabel="Past Email Blast"
            channelLabel="Email"
            icon="bi-send"
        />
    );
}

export default EmailBlastResults;
